module.exports = __webpack_public_path__ + "img/Potato.282b9458.svg";